import { Component } from '@angular/core';

@Component({
	templateUrl: './badRequest.component.html'
})
export class BadRequestComponent {}
